<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <app-page-retrieval-error
    *ngIf="pageRetrievalError"
  ></app-page-retrieval-error>

  <!-- Uni Partner banner -->
  <div
    [ngClass]="{ unihome: auth.currentUser?.university?.is_unihome_product }"
    *ngIf="showUniPartnerBanner"
  >
    <app-partner-banner
      [partnerId]="uniPartnerId"
      source="UNIVERSITY"
    ></app-partner-banner>
  </div>

  <!-- Accommodation Partner banner -->
  <app-partner-banner
    *ngIf="showAccommodationPartnerBanner"
    [partnerId]="accommodationPartnerId"
    source="ACCOMMODATION"
  ></app-partner-banner>

  <!-- Confirm your cover section -->
  <section class="cyc-padding" *ngIf="shouldShowCYC">
    <div class="content-wrapper cyc-banner header-container">
      <div class="cyc-banner-text">
        <h1>{{ cycDashboardBanner.title }}</h1>
        <div class="content">
          <h2>{{ cycDashboardBanner.subtitle }}</h2>
          <p>
            {{ auth.currentUser?.accommodation?.name }}
            {{ cycDashboardBanner.content }}
          </p>
        </div>
      </div>
      <button class="button btn" (click)="showCYCModal = true">
        {{ cycDashboardBanner.button_text }}
      </button>
    </div>
  </section>
  <!-- Confirm your cover end -->

  <!-- International students banner -->
  <section class="is-section" *ngIf="this.showInternationalStudentBanner">
    <div class="content-wrapper international-student header-container">
      <div class="content">
        <!-- Title -->
        <h1 class="title">
          {{ this.auth.currentUser?.university?.pathway_provider_title }}
        </h1>
        <!-- Content -->
        <p class="body">
          {{ this.internationalStudentPageData.dashboard_banner_content }}
        </p>
      </div>
      <button class="button" (click)="onNavigate(DashboardEnum.ISRoute)">
        {{ this.internationalStudentPageData.dashboard_banner_cta }}
      </button>
    </div>
  </section>
  <!-- International students banner end -->

  <app-banner
    [pageData]="pageData"
    [useAlternateBanner]="
      auth.currentUser?.university?.is_pathway_provider ? false : showCYCBanner
    "
    *ngIf="!auth.currentUser?.university?.is_unihome_product"
  ></app-banner>

  <!-- Confirm your Cover modal -->
  <app-modal
    *ngIf="showCYCModal"
    [show]="showCYCModal"
    [showBuddy]="false"
    [cycModal]="true"
    (showChange)="onCoverModalDisplayChange($event)"
  >
    <app-confirm-your-cover></app-confirm-your-cover>
  </app-modal>
  <!-- Confirm your cover modal -->

  <!-- Onboarding modal -->
  <app-modal
    [show]="shouldShowOnboarding"
    [showBuddy]="true"
    (showChange)="onOnboardingModalDisplayChange($event)"
  >
    <app-onboarding></app-onboarding>
  </app-modal>
  <!-- Onboarding modal end -->

  <!-- Student wellbeing section -->
  <section
    class="dashboard-section"
    [ngClass]="
      !auth.currentUser?.university?.is_unihome_product
        ? 'wellbeing-background'
        : ''
    "
    *ngIf="
      (pageData?.enable_wellbeing_section && showWellbeing) ||
      pageData?.enable_student_life_section
    "
    [class.student-life-padding]="pageData?.enable_student_life_section"
  >
    <div
      class=""
      [ngClass]="
        auth.currentUser?.university?.is_unihome_product
          ? 'wellbeing-background'
          : 'content-wrapper'
      "
      *ngIf="pageData?.enable_wellbeing_section && showWellbeing"
    >
      <div
        [ngClass]="
          auth.currentUser?.university?.is_unihome_product
            ? 'content-wrapper'
            : ''
        "
      >
        <button
          class="section-heading unstyled-button"
          (click)="onNavigate(DashboardEnum.wellbeingRoute)"
        >
          <h1>Student wellbeing</h1>
        </button>
        <app-student-wellbeing-carousel
          *ngIf="studentWellbeingCards.length"
          [carousel]="studentWellbeingCards"
          [helplineData]="helplineData"
        >
        </app-student-wellbeing-carousel>
      </div>
    </div>

    <!-- Student guard banner -->
    <app-student-guard-banner
      *ngIf="showStudentGuardBanner"
      [banner]="pageData.student_guard_banner?.data?.attributes"
    ></app-student-guard-banner>

    <div class="content-wrapper" *ngIf="pageData?.enable_student_life_section">
      <button
        class="section-heading unstyled-button"
        (click)="onNavigate(DashboardEnum.studentLifeRoute)"
      >
        <h1
          [ngClass]="{
            'primary-accent': auth.currentUser?.university?.is_unihome_product,
            'margin-top': !showStudentGuardBanner
          }"
        >
          Student life
        </h1>
      </button>
    </div>
  </section>
  <!-- Student wellbeing section end -->

  <!-- Student life section -->

  <section
    class="dashboard-section student-life"
    [ngClass]="
      auth.currentUser?.university?.is_unihome_product ? 'is-unihome' : ''
    "
    *ngIf="pageData?.enable_student_life_section"
  >
    <div class="content-wrapper">
      <app-student-life-carousel
        *ngIf="studentLifeCards.length"
        [carousel]="studentLifeCards"
      >
      </app-student-life-carousel>
    </div>
  </section>
  <!-- Student wellbeing section end -->

  <!-- Jobs and careers section -->
  <section
    class="dashboard-section"
    *ngIf="this.pageData.enable_jobs_and_careers"
  >
    <div class="content-wrapper">
      <button
        class="section-heading unstyled-button"
        (click)="onNavigate(DashboardEnum.JACRoute)"
      >
        <h1 class="primary-accent">Jobs and careers</h1>
      </button>
      <app-vertical-carousel
        *ngIf="jobsAndCareersCards.length"
        [carousel]="jobsAndCareersCards"
      >
        <ng-template let-slide>
          <app-jobs-and-careers-carousel-slide
            [slide]="slide"
          ></app-jobs-and-careers-carousel-slide>
        </ng-template>
      </app-vertical-carousel>
    </div>
  </section>

  <!-- Latests offers section -->

  <section *ngIf="pageData?.enable_offers_section">
    <div class="content-wrapper">
      <button
        class="section-heading unstyled-button"
        (click)="onNavigate(DashboardEnum.topOffersRoute)"
      >
        <h1 class="primary-accent">OUR LATEST OFFERS</h1>
      </button>
      <app-vertical-carousel
        *ngIf="latestOffersCards.length"
        [carousel]="latestOffersCards"
      >
      </app-vertical-carousel>
    </div>
  </section>

  <!-- Latests offers section end  -->

  <!-- Protect and save section -->
  <section
    class="dashboard-section protect-and-save"
    *ngIf="protectAndSaveSection"
  >
    <div class="content-wrapper">
      <button
        class="section-heading unstyled-button"
        (click)="onNavigate(DashboardEnum.protectAndSaveRoute)"
      >
        <h1 class="primary-accent">Protect and save</h1>
      </button>
      <app-protect-and-save-dashboard-component
        *ngIf="protectAndSaveProducts.length"
        [carousel]="protectAndSaveProducts"
      >
      </app-protect-and-save-dashboard-component>
    </div>
  </section>
  <!-- Protect and save section end -->

  <!-- My Insurance - Start -->
  <section class="my-insurance-section" *ngIf="showDashboardInsuranceSection">
    <div class="content-wrapper">
      <div class="spinner" *ngIf="isLoading; else showMyInsurance"></div>
      <ng-template #showMyInsurance>
        <button
          class="section-heading unstyled-button"
          (click)="onNavigate(DashboardEnum.myInsuranceRoute)"
        >
          <h1>My insurance</h1>
        </button>
        <div class="my-insurance-wrapper">
          <app-my-insurance-section
            [userInsuranceProducts]="insuranceProducts"
          ></app-my-insurance-section>
        </div>
      </ng-template>
    </div>
  </section>
  <!-- My Insurance - End -->
</div>
